module.exports = __webpack_public_path__ + "static/media/logo-blue.63cec63b.png";